import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { GbgrundstueckService, GrundstueckSearchRequestErweitertMeta } from '../../../core/gb-api';
import { GrundstueckFormService } from '../../grundstueck-form-service';
import { ActivatedRoute, Router } from '@angular/router';
import { GbGemeindeSearchMode as GbGemeindeSearchMode } from '../../../shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { GbGemeindeComponent } from '../../../shared/widgets/gb-gemeinde/gb-gemeinde.component';
import { TimepointService } from '../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../shared/enum/searchMode';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { OrtschaftSelectionComponent } from '../../../shared/widgets/ortschaft/ortschaft-selection.component';
import { GrundstueckSelectionComponent } from '../../../shared/widgets/grundstuecktype-selection/grundstuecktype-selection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundstueck-suche-erweitert',
  templateUrl: './grundstueck-suche-erweitert.component.html',
  styleUrls: ['./grundstueck-suche-erweitert.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    GbGemeindeComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    OrtschaftSelectionComponent,
    GrundstueckSelectionComponent,
    TranslatePipe
  ]
})
export class GrundstueckSucheErweitertComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @Output()
  tabErweitertActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(GbGemeindeComponent, { static: false })
  private gbGemeindeComponent: GbGemeindeComponent;

  gsErweitert: GrundstueckSearchRequestErweitertMeta;
  gbGemeindeSearchMode = GbGemeindeSearchMode.GRUNDSTEUCK_REGISTER_SEARCH;

  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private grundstueckService: GbgrundstueckService,
    private formService: GrundstueckFormService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    if (this.stateService.lastRequest && this.stateService.lastSearchMode === SearchMode.searchErweitert) {
      this.gsErweitert = this.stateService.lastRequest;
    } else {
      this.gsErweitert = <GrundstueckSearchRequestErweitertMeta>{};
    }

    this.subscription = this.grundstueckService
      .searchGrundstueckErweitertTemplate()
      .subscribe((template) => (this.gsErweitert = this.copyLastRequest(template, SearchMode.searchErweitert)));
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.gsErweitert;
    this.timepointService.resetTimepoint();
    this.formService.submit(this.form, SearchMode.searchErweitert, this.gsErweitert, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.grundstueckService.searchGrundstueckErweitertTemplate().subscribe((template) => {
      this.gsErweitert = template;
      this.gbGemeindeComponent.focus();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
